import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { WorkerInfo } from 'src/types/common.types';

const fetchData = async () => {
  const response = await ApiService.get<WorkerInfo[]>('/api/workers/work_items');
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy hạng mục công việc',
    });
    return [];
  }
  return data;
};

const useWorkItems = () => {
  return useQuery({
    queryKey: ['work-items'],
    queryFn: fetchData,
    staleTime: 1000 * 60 * 5,
  });
};

export default useWorkItems;
